import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DictionaryField,
  DictionaryFieldFromApi,
  PortalId,
} from '@gk/gk-modules';
import { Observable, map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PAROwnerService {
  private cache = new Map<PortalId, Observable<DictionaryField[]>>();

  constructor(private httpClient: HttpClient) {}

  get(portalId: PortalId): Observable<DictionaryField[]> {
    if (!this.cache.has(portalId)) {
      this.cache.set(
        portalId,
        this.httpClient
          .get<
            DictionaryFieldFromApi[]
          >(`/api/interesant/wniosekDoAktuPlanowaniaPrzestrzennego/portal/${portalId}/owner`)
          .pipe(
            map((owner) =>
              owner.map((item) => DictionaryField.fromApiToApp(item)),
            ),
            shareReplay(1),
          ),
      );
    }

    return this.cache.get(portalId);
  }
}
